import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { openModal, openRC, openMS, openAnn } from "store/actions"
import AgendaModal from "../../pages/UIcomponents/AgendaModal"

// import 'bootstrap/dist/css/bootstrap.min.css';

import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  Modal,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Media,
  Row,
  Col,
} from "reactstrap"
import classnames from "classnames"
import parse from "html-react-parser"
// import Alldata from "../../assets/localdata.json"

var tawklink = ""

const Alldata = JSON.parse(localStorage.getItem("dataJ"))
let agendalink = ""
const SidebarContent = props => {
  const [modalQAVisible, setModalQAVisible] = useState(false)
  const [theAgenda, setTheAgenda] = useState(false)
  const [modalPrefernceVisible, setModalPreferenceVisible] = useState(false)

  const obj = JSON.parse(localStorage.getItem("authUser"))
  const { modal, onOpenModal } = props
  const { rc, onOpenRC } = props
  const { ms, onOpenMS } = props
  const { ann, onOpenAnn } = props

  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }
  const [ActiveTab, setActiveTab] = useState(Alldata.data.agenda.data.day1.name)
  const [helprc, onhelpOpenRC] = useState(false)
  const [agendaModalOpen, setAgendaModalOpen] = useState(false)

  const toggleAgendaModal = () => {
    setAgendaModalOpen(!agendaModalOpen)
  }

  const toggleCustom = tab => {
    if (ActiveTab !== tab) {
      setActiveTab(tab)
    }
  }
  const [rs, setRS] = useState(false)
  const togglers = () => {
    setRS(!rs)
  }

  const togglePrefernceModal = () => {
    setModalPreferenceVisible(!modalPrefernceVisible)
  }
  const toggleQAModal = () => {
    setModalQAVisible(!modalQAVisible)
  }

  const toggleTheAgenda = () => {
    setTheAgenda(!theAgenda)
  }

  const [rcc, setRCC] = useState("")
  return (
    <React.Fragment>
      <AgendaModal isOpen={agendaModalOpen} toggle={toggleAgendaModal} />

      <Modal
        isOpen={rs}
        toggle={togglers}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Opening Soon!</h5>
          <button
            type="button"
            onClick={togglers}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body" style={{ color: "#00A982" }}>
          {rcc}
        </div>
      </Modal>

      <Modal size="xl" isOpen={modal} toggle={onOpenModal} centered={true}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myExtraLargeModalLabel">
            Agenda
          </h5>
          <button
            onClick={onOpenModal}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {/* {props.data.areas.map((item, i) => (
                <>
                  {(() => {
                    switch (item.linktype) {
                      case "agendatypelist": {
                        <div style={{ display: "none" }}>
                          {item.url ? agendalink = item.url : agendalink = ""}
                        </div>
                      }
                    }
                  })()}
                </>
              ))} */}
          {/* <iframe
                id={Alldata.data.lobby.data.areas[3].name}
                src={
                  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/" +
                  encodeURIComponent(agendalink)
                  +
                  "?alt=media"
                }
                height="550px"
                width="100%"
              ></iframe> */}
          <Card>
            <CardBody>
              {/* <CardTitle className="h4">Agenda</CardTitle> */}
              {/* <p className="card-title-desc">Example of custom tabs</p> */}

              <Nav tabs className="nav-tabs-custom nav-justified">
                {Object.keys(Alldata.data.agenda.data).map((day, idx) => (
                  <NavItem key={idx}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active:
                          ActiveTab === Alldata.data.agenda.data[day].name,
                      })}
                      onClick={() => {
                        toggleCustom(Alldata.data.agenda.data[day].name)
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="mdi mdi-apple-airplay"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        {Alldata.data.agenda.data[day].name}
                      </span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
              <TabContent activeTab={ActiveTab} className="p-3 text-muted">
                {Object.keys(Alldata.data.agenda.data).map((day, idx) => (
                  <TabPane key={idx} tabId={Alldata.data.agenda.data[day].name}>
                    {Alldata.data.agenda.data[day].data.map((cardo, idc) => {
                      return (
                        <Row key={idc}>
                          <Col sm="12">
                            <Card>
                              <CardBody>
                                <Media>
                                  <div className="me-3">
                                    {/* <img
                              src={avatar}
                              alt=""
                              className="avatar-md rounded-circle img-thumbnail"
                            /> */}
                                  </div>
                                  <Media body className="align-self-center">
                                    {cardo.redirect && (
                                      <a href={cardo.redirect}>
                                        <button
                                          className="btn btn-danger"
                                          style={{
                                            position: "absolute",
                                            right: "10px",
                                          }}
                                        >
                                          {(cardo.btnText && cardo.btnText) ||
                                            "Join"}
                                        </button>
                                      </a>
                                    )}

                                    <div className="text-muted">
                                      <h5>{cardo.title}</h5>
                                      <h6>{cardo.time}</h6>
                                      {cardo.des && (
                                        <p className="mb-1">
                                          {parse("" + cardo.des)}
                                        </p>
                                      )}
                                    </div>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      )
                    })}
                  </TabPane>
                ))}
              </TabContent>
            </CardBody>
          </Card>
        </div>
      </Modal>

      <Modal
        isOpen={helprc}
        toggle={() => onhelpOpenRC(!helprc)}
        centered={true}
        style={{ width: "auto" }}
      >
        {/* Header */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 18px",
          borderTopLeftRadius: "16px", borderTopRightRadius: "16px",
          background: "linear-gradient(135deg, #cc2134 0%, #fed65d 100%)",
          borderBottom: "1px solid rgba(204, 33, 52, 0.18)"
        }}>
          <h5 style={{ margin: 0, color: "#fff", fontSize: 16, fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}>
            Help Desk <i className="bx bxs-help-circle" style={{ color: "#fed65d" }} />
          </h5>
          <button
            onClick={() => onhelpOpenRC(!helprc)}
            type="button"
            aria-label="Close"
            style={{
              background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 8, color: "#fff", width: 32, height: 32,
              cursor: "pointer", fontSize: 18, lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center"
            }}
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="modal-body" style={{ background: "#f7faf9", padding: "16px", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}>
          <div style={{
            background: "#fff", borderRadius: 12,
            border: "1px solid rgba(204, 33, 52, 0.18)",
            boxShadow: "0 4px 20px rgba(0,60,40,0.08)",
            overflow: "hidden"
          }}>
            {Alldata.data.lobby.data.areas.map((item, i) =>
              (() => {
                switch (item.id) {
                  case "help": {
                    ;<div style={{ display: "none" }}>
                      {item.url ? (tawklink = item.url) : (tawklink = "")}
                    </div>
                  }
                }
              })()
            )}
            <iframe
              height="450px"
              width="100%"
              title="test"
              className="embed-responsive-item"
              src="https://tawk.to/chat/68a0486120531719265ca15a/1j2p1lfqa"
              style={{ display: "block", border: "none" }}
            />
          </div>
        </div>

        {/* Footer accent */}
        <div style={{ height: 3, width: "94%", margin: "0 auto", background: "linear-gradient(90deg, #cc2134, #fed65d, #cc2134)", borderRadius: "0 0 16px 16px" }} />
      </Modal>

      <Modal
        size="lg"
        isOpen={modalQAVisible}
        toggle={toggleQAModal}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Share your views</h5>
          <button
            type="button"
            onClick={() => {
              setModalQAVisible(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="500px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src="https://app.sli.do/event/qMvMJFk3tziGvC7kRnJgJX"
          />
        </div>
      </Modal>

      {/* The Agenda  */}
      <Modal
        size="lg"
        isOpen={theAgenda}
        toggle={toggleTheAgenda}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">The Agenda</h5>
          <button
            type="button"
            onClick={() => {
              setTheAgenda(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="500px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Idea%20Forge%2Fagenda.pdf?alt=media&token=cf174aa2-4a50-44c2-8370-5dac86d72bef"
          />
        </div>
      </Modal>

      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("INFORMATION")} </li>
            {/* <li>
              <Link to="/page/lobby" className="">
                <i className="bx bx-home-circle "></i>
                <span>{props.t("Home")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/page/auditorium" className="">
                <i class="bx bxl-audible"></i>
                <span>{props.t("Auditorium")}</span>
              </Link>
            </li>

            {/* <li onClick={() => { onhelpOpenRC(!helprc) }}>
              <Link to="/page/desklobby" className="">
              <a>
                <i className="mdi mdi-help-circle-outline "></i>
                <span>{props.t("Help Desk")}</span>
              </a>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/record" className="">
              <i className="bx bx-video"></i>
              <span>{props.t("Recorded Session")}</span>
              </Link>
            </li> */}

             

            <li className="menu-title">{props.t("Engagement")} </li>
            
            <li>
              <Link to="/page/photobooth" className="">
              <i className="bx bx-camera"></i>
              <span>{props.t("Photobooth")}</span>
              </Link>
            </li>

             <li>
              <Link to="/graffitiWall" className="">
                <i class='bx bx-star'></i> 
                <span>{props.t("Gallary")}</span>
              </Link>
            </li>

            


            

            {/* <li>
            <Link to="/page/helpdesk" className="">
                <i className="mdi mdi-help-circle-outline "></i>
                <span>{props.t("Help Desk")}</span>
                </Link>
            </li> */}
            {/* {Alldata.data.exhibitionarea ? 
            Alldata.data.exhibitionarea.edata.restricted
            ? <li onClick={()=>{setRCC(Alldata.data.exhibitionarea.edata.restrictdata.text);togglers()}}>
              <a>
              <i className="bx bx-book-add"></i>
                <span>{props.t("Exhibition Hall")}</span>
              </a>
            </li>           
            : <li>
              <Link to="/page/exhibitionarea" className="">
              <i className="bx bx-book-add"></i>
                <span>{props.t("Exhibition Hall")}</span>
              </Link>
            </li>
            :
            null
            } */}
            {/* <li>
              <Link to="/speakers" className="">
                <i >
                {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </i>
                <span>{props.t("Judges Profile")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/page/author" className="">
              <i className="bx bx-star"></i>
              <span>{props.t("Author's Corner")}</span>
              </Link>
            </li> */}

            {/* <li className="menu-title">{props.t("SESSIONS")} </li> */}

            {/* agenda */}
            {/* <li onClick={}>
              // onClick={onOpenModal}
              <Link >
                <a href="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Idea%20Forge%2Fagenda.pdf?alt=media&token=cf174aa2-4a50-44c2-8370-5dac86d72bef">
                <i className="bx bx-calendar-event "></i>
                <span>{props.t("Agenda")}</span>
                </a>
              </Link>
            </li> */}

            {/* another agenda */}
            {/* <li onClick={toggleAgendaModal}>
              <Link >
              <a>
                <i className="bx bx-calendar-event "></i>
                <span>{props.t("Agenda")}</span>
              </a>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/page/speakers" className="">
                <i >
                {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </i>
                <span>{props.t("Speakers")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/page/sponsors" className="">
              <i className="bx bx-star"></i>
              <span>{props.t("Sponsors")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/auditorium" className="">
                <i className="mdi mdi-apple-airplay "></i>
                <span className="badge rounded-pill bg-info float-end">
                  
                </span>
                <span>{props.t("Auditorium")}</span>
              </Link> */}
            {/* <ul className="sub-menu" aria-expanded="false">
              <li>
              <Link to="/page/audi1" className="">
                <i className="mdi mdi-apple-airplay newcol"></i>
                <span>{props.t("Auditorium-1")}</span>
              </Link>
            </li>
            <li>
              <Link to="/page/audi2" className="">
                <i className="mdi mdi-apple-airplay newcol"></i>
                <span>{props.t("Auditorium-2")}</span>
              </Link>
            </li>
            <li>
              <Link to="/page/audi3" className="">
                <i className="mdi mdi-apple-airplay newcol"></i>
                <span>{props.t("Auditorium-3")}</span>
              </Link>
            </li>
            <li>
              <Link to="/page/audi4" className="">
                <i className="mdi mdi-apple-airplay newcol"></i>
                <span>{props.t("Auditorium-4")}</span>
              </Link>
            </li>
              </ul> */}
            {/* </li> */}

            {/* <li>
              <Link to="/#" className="">
                <i className="mdi mdi-apple-airplay"></i>
                <span>{props.t("Auditorium-1")}</span>
              </Link>
            </li>
            <li>
              <Link to="/page/audi2" className="">
                <i className="mdi mdi-apple-airplay"></i>
                <span>{props.t("Auditorium-2")}</span>
              </Link>
            </li>
            <li>
              <Link to="/page/audi3" className="">
                <i className="mdi mdi-apple-airplay"></i>
                <span>{props.t("Auditorium-3")}</span>
              </Link>
            </li>
            <li>
              <Link to="/page/audi4" className="">
                <i className="mdi mdi-apple-airplay"></i>
                <span>{props.t("Auditorium-4")}</span>
              </Link>
            </li> 
            */}

            {/* <li className="menu-title">{props.t("INFORMATION")} </li> */}

            {/* <li>
              <Link to="/page/agendaforevent" className="">
              
              <i className='bx bx-shape-square'></i>
              <span>{props.t("Agenda")}</span>
              </Link>
            </li> */}

            {/* <li onClick={onOpenAnn}>
              <a>
                <i className="bx bxs-bell-ring"></i>
                <span>{props.t("Push Notification")}</span>
              </a>
            </li> */}

            {/* <li onClick={toggleQAModal}>
              <Link to="/page/lobby" className="">
                <i class="bx bx-shape-square"></i>
                <span>{props.t("Polls")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/products" className="">

                <i className="bx bx-calendar-event "></i>
                <span>{props.t("Products")}</span>
              </Link>
            </li> */}

            {/* <li onClick={toggleTheAgenda}>
              <a to="#" className="">
                <i class="bx bx-food-menu"></i>
                <span>{props.t("Agenda")}</span>
              </a>
            </li> */}

            {/* <li onClick={togglePrefernceModal}>
              <Link to="/page/lobby" className="">
                <i class="bx bx-food-menu"></i>
                <span>{props.t("Agenda")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/Leaderboard" className="">
                <i class="bx bx-medal"></i>
                <span>{props.t("Leaderboard")}</span>
              </Link>
            </li> */}

           

            {/* <li>
              <Link to="/page/photogallery" className="">
              
              <i className='bx bx-photo-album'></i>
              <span>{props.t("Photo Gallery")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/comingsoon" className="">
              <i className="bx bx-star"></i>
              <span>{props.t("Video Gallery")}</span>
              </Link>
            </li>    */}

            {/* <li>
              <Link to="/page/FAQs" className="">
              
              <i className="bx bx-file"></i>
              <span>{props.t("FAQs")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/grantitude" className="">
              <i className="bx bx-pencil"></i>
              <span>{props.t("GRANTitude")}</span>
              </Link>
            </li>        */}

            {/* {Alldata.data.networkingzone ? 
            Alldata.data.networkingzone.edata.restricted
            ? <li onClick={()=>{setRCC(Alldata.data.networkingzone.edata.restrictdata.text);togglers()}}>
              <a>
              <i className="bx bx-chat"></i>
              <span>{props.t("Networking Zone")}</span>
              </a>
            </li>           
            : <li>
              <Link to="/page/networkingzone" className="">
              <i className="bx bx-chat"></i>
              <span>{props.t("Networking Zone")}</span>
              </Link>
            </li>
            :
            null
            }  */}

            {/* <li>
              <Link to="/#" className="">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </i>
                <span>{props.t("Photo Mosaic")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/page/pageprogram" className="">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </i>
                <span>{props.t("Programs")}</span>
              </Link>
            </li> */}

            {/* <li className="menu-title">{props.t("INFORMATION")} </li> */}
            {/* <li>
              <Link to="/page/bcard" className="">
                <i className="bx bx-dock-top"></i>
                <span>{props.t("Business Cards")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/page/meetings" className="">
                <i className="bx bx-layout"></i>
                <span>{props.t("Meetings")}</span>
              </Link>
            </li> */}

            {/* <li onClick={onOpenRC}>
              <a>
                <i className="bx bx-file newcol"></i>
                <span>{props.t("Resource Center")}</span>
              </a>
            </li> */}

            {/* <li>
              <Link to="/page/photozone" className="">
                <i className="bx bx-camera"></i>
                <span>{props.t("Photo Zone")}</span>
              </Link>
            </li> */}
            {/* photobhooth */}
            {/* <li>
            <a href={process.env.REACT_APP_PhotoBooth+"?email="+obj.Email+"&name="+obj.Firstname} target="_blank" className="">
              <i className="bx bx-camera"></i>
                <span>{props.t("Photo Booth")}</span>
              </a>
            </li>

            {Alldata.data.mosaic ?
            Alldata.data.mosaic.edata.restricted
            ? <li onClick={()=>{setRCC(Alldata.data.mosaic.edata.restrictdata.text);togglers()}}>
              <a>
              <i className="bx bx-camera"></i>
                <span>{props.t("Photo Mosaic")}</span>
              </a>
            </li>           
            : 
            <li onClick={()=>{onOpenMS()}}>
              <a>
                <i className="bx bx-camera"></i>
                <span>{props.t("Photo Mosaic")}</span>
              </a>
            </li>
            :
            null
            }  */}

            {/* <li>
              <a href={"https://master.daplqztvfoa6c.amplifyapp.com/?id="+obj.Email+"|"+obj.Firstname} target="_blank" className="">
              <Link to="/page/games-img" className="">
             
                <i className="bx bx-webcam"></i>
                <span>{props.t("1:1 Interaction")}</span>
              </Link>
            </li>   */}

            {/* <li>
            <a href={"https://"+window.location.host+"/activityfeed"} className="">
            <Link to="/activityfeed" className="">
                <i className="bx bx-been-here"></i>
                <span>{props.t("AR Invite")}</span>
              </Link>
              </a>
            </li> */}

            {/* <li>
              <Link to="/page/arinvite" className="">
              <i className='bx bxl-mastercard'></i>
              <span>{props.t("AR Invite")}</span>
              </Link>
            </li>  */}

            {/* <li>
              <Link to="/page/socialwall" className="">
                <i className="bx bx-been-here"></i>
                <span>{props.t("Social Media Wall")}</span>
              </Link>
            </li> */}
            {/* {Alldata.data.grantitude ? (
              <li>
                <Link to="/page/grantitude" className="">
                  <i className="bx bx-pencil"></i>
                  <span>{props.t("Gratitude Card")}</span>
                </Link>
              </li>
            ) : (
              <li>
                <Link to="/grantitude" className="">
                  <i className="bx bx-pencil"></i>
                  <span>{props.t("Gratitude Card")}</span>
                </Link>
              </li>
            )} */}

            {/* <li className="menu-title">{props.t("Interaction")} </li> */}

            {/* <li>
              <a
                href={
                  'https://www.ideaforge-pragya2025.com/photobooth/' +
                  "?email=" +
                  obj.Email +
                  "&name=" +
                  obj.Firstname
                }
                target="_blank"
                className=""
              >
                <i className="bx bx-camera"></i>
                <span>{props.t("Photo Booth")}</span>
              </a>
            </li> */}

            {/* <li>
              <a
                href={'https://ideaforge.dqb9d7jasgckq.amplifyapp.com/?email='}
                target="_blank"
                className=""
              >
                <i className="bx bx-book-add"></i>
                <span>{props.t("Puzzle")}</span>
              </a>
            </li> */}

            {/* <li>
              <Link to="/page/engagementzone" className="">
                <i className="bx bx-book-add"></i>
                <span>{props.t("Engagement Zone")}</span>
              </Link>
            </li> */}



            {/* <li>
              <a target="_blank" href={
                        "https://apple.d1zqbqpxh659q4.amplifyapp.com/?id="+
                        obj.Email +
                        "|" +
                        obj.Firstname +
                        "|" +
                        "&admin=" +
                        btoa(
                          process.env.REACT_APP_ADMIN + "/submitscore"
                        ) +
                        "&platform=" +
                        btoa(window.location.origin + "/leaderboard")
                      }
              >
                <i class="bx bx-dice-6"></i>
                <span>{props.t("Quiz")}</span>
              </a>
            </li> */}


            {/* <li>
              <Link to="/page/graffiti" className="">
                <i className="bx bx-pencil"></i>
                <span>{props.t("Graffiti Wall")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/quiz" className="">
                <i className="bx bx-dice-6"></i>
                <span>{props.t("Quiz")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/photobooth" className="">
              <i className="bx bx-camera"></i>
              <span>{props.t("Selfie")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/networking" className="">
              <i className="bx bx-pencil"></i>
              <span>{props.t("One on One Chat")}</span>
              </Link>
            </li>
            <li>
              <Link to="/activityfeed" className="">
              <i className="bx bx-been-here"></i>
                <span>{props.t("Group Chat")}</span>
              </Link>
            </li>

            <li onClick={toggleQAModal}>
            <a>
              <i className='bx bx-git-pull-request'></i>
              <span>{props.t("Live Q&A")}</span>
            </a>
            </li> */}
            {/* <li onClick={togglePrefernceModal}>
              <Link to="/page/lobby" className="">
              <i class='bx bx-food-menu'></i>
              <span>{props.t("Dietary Preferences")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/preferences" className="">
              
              <i className="bx bx-food-menu"></i>
              <span>{props.t("Customer Preferences")}</span>
              </Link>
            </li>
            */}
            {/* <li>
              <Link to="/page/Speakers" className="">
              
              <i class='bx bx-user' ></i>
              <span>{props.t("Speaker profile")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/weather" className="">
              
              <i className="bx bx-cloud"></i>
              <span>{props.t("Weather")}</span>
              </Link>
            </li> */}

            {/* <li onClick={onOpenAnn}>
              <a>
                <i className="bx bxs-bell-ring"></i>
                <span>{props.t("Notification")}</span>
              </a>
            </li> */}
            {/* <li onClick={onOpenRC}> */}
            {/* <li >
              <Link to="/page/bookmark" className="">
                <i className="bx bx-bookmark newcol"></i>
                <span>{props.t("Bookmark")}</span>
              </Link>
            </li> */}
            {/* <li >
              <Link to="/profile" className="">
                <i className="bx bx-barcode newcol"></i>
                <span>{props.t("QR code")}</span>
              </Link>
            </li>
            <li >
              <Link to="/profile" className="">
                <i className="bx bx-user newcol"></i>
                <span>{props.t("Profile")}</span>
              </Link>
            </li> */}
            {/* <li >
              <Link to="/page/pdflib" className="">
                <i className="bx bx-file newcol"></i>
                <span>{props.t("Pdf Library")}</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  modal: PropTypes.any,
  rc: PropTypes.any,
  location: PropTypes.object,
  t: PropTypes.any,
  onOpenModal: PropTypes.any,
  onOpenRC: PropTypes.any,
  onOpenAnn: PropTypes.any,
  onOpenAnn2: PropTypes.any,

}

const mapStateToProps = ({ agenda }) => ({
  modal: agenda.modal,
  rc: agenda.rc,
  ms: agenda.ms,
  ann: agenda.ann,
})

const mapDispatchToProps = dispatch => ({
  onOpenModal: () => dispatch(openModal()),
  onOpenRC: () => dispatch(openRC()),
  onOpenMS: () => dispatch(openMS()),
  onOpenAnn: () => dispatch(openAnn()),
  onOpenAnn2: () => dispatch(openAnn2()),

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(SidebarContent)))
